const normalizeBaseUrl = (value, fallback) => {
  const candidate = (value || fallback || '').trim()
  if (!candidate) {
    return ''
  }
  return candidate.replace(/\/+$/, '')
}

const resolvePublicApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname === 'test.primusvest.ro') {
    return '/api/v1'
  }

  return normalizeBaseUrl(
    process.env.REACT_APP_PUBLIC_API_BASE_URL,
    'https://api.primusvest.ro/v1'
  )
}

export const PUBLIC_API_BASE_URL = resolvePublicApiBaseUrl()

const isDevPublicHost = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const { hostname } = window.location
  return hostname === 'test.primusvest.ro' ||
    hostname.endsWith('.primusvest.pages.dev')
}

export const TURNSTILE_SITE_KEY = (process.env.REACT_APP_TURNSTILE_SITE_KEY || '').trim()
export const TURNSTILE_BYPASSED = isDevPublicHost()
export const TURNSTILE_ENABLED = Boolean(TURNSTILE_SITE_KEY) && !TURNSTILE_BYPASSED

export const buildPublicApiUrl = (path = '') => {
  const normalizedPath = String(path || '').replace(/^\/+/, '')
  if (!normalizedPath) {
    return PUBLIC_API_BASE_URL
  }
  return `${PUBLIC_API_BASE_URL}/${normalizedPath}`
}
